import { useEffect, useState } from "react";
import { adminListCertificates } from "@/lib/apiClient";
import { Award } from "lucide-react";

export default function AdminCertificates() {
  const [rows, setRows] = useState([]);
  useEffect(() => { adminListCertificates().then(setRows); }, []);

  return (
    <div data-testid="admin-certificates">
      <h1 className="font-heading text-2xl sm:text-3xl font-semibold text-[#1F2937]">Certificates Issued</h1>
      <div className="mt-6 rounded-2xl bg-white border border-[#E7E0D2] overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#FDFBF7] text-[#4B5563] text-left">
            <tr>
              <th className="px-4 py-3 font-medium">Student</th>
              <th className="px-4 py-3 font-medium">Certificate No.</th>
              <th className="px-4 py-3 font-medium">Issued</th>
              <th className="px-4 py-3 font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={4} className="text-center py-10 text-[#4B5563]">No certificates issued yet.</td></tr>}
            {rows.map((c) => (
              <tr key={c.cert_number} className="border-t border-[#E7E0D2]" data-testid={`cert-${c.cert_number}`}>
                <td className="px-4 py-3 font-medium text-[#1F2937]">{c.user_name}</td>
                <td className="px-4 py-3 font-mono text-[#064E3B]">{c.cert_number}</td>
                <td className="px-4 py-3 text-[#4B5563]">{new Date(c.issued_at).toLocaleString()}</td>
                <td className="px-4 py-3">
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#D1FAE5] text-[#065F46] text-xs font-medium">
                    <Award className="w-3 h-3" /> {c.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
